import {Component, OnInit} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {setSEOInfo} from '@shared/helpers/seo';
import {Location} from '@angular/common';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {

  constructor(private title: Title, private meta: Meta, private location: Location) {
    const pageName = 'Page not found';
    const desc = 'Page not found';
    setSEOInfo(this.title, this.meta, pageName, desc);
  }

  goBack() {
    this.location.back();
  }
}
